/* eslint-disable */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Tooltip } from 'react-tippy';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowUp,
  faArrowDown,
} from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';
import * as globalActions from '../../actions/global';
import { TextInput } from '@trueprodigy/components';
import NoDataHolder from '../_components/noDataHolder';
import RefreshIndicator from '../_components/refreshIndicator';
import Pagination from '../_components/pagination';
import CustomTooltip from '../_components/customTooltip';
import { fetchingState } from '../../constants';
import selector from './selector';
import searchIcon from '../../assets/images/search-regular.svg';
import closeIcon from '../../assets/images/times-light.svg';
import { removeNullCharacter } from '../../utils';
import SvgIcon from '@material-ui/core/SvgIcon';
import './index.scss';
const mainImage = require('../../assets/images/tt-image1-01.png');
const screenshotImage = require('../../assets/images/my-properties-screenshot.png');

const PropertySearch = ({
  propertyList,
  changePageSize,
  queryString,
  office,
  fetchImportStatus,
  fetchSearchResultConfig,
  changeQueryString,
  changeSortModel,
  changeCurrentPage,
  search,
  history,
  searchResultConfig,
  clientConfig,
  importStatus
}) => {
  const importStatusJs = importStatus && importStatus.get('data');

  useEffect(() => {
    fetchSearchResultConfig();
    fetchImportStatus();
  }, []);

  const triggerSearch = async (page, sortModel) => {
    if (!queryString) {
      return;
    }
    const searchOptions = { queryString };

    let sModel;
    if (sortModel) {
      sModel = sortModel;
    } else if (propertyList.get('sortModel')) {
      sModel = propertyList.get('sortModel').toJS();
    }
    const response = await search({
      page,
      pageSize: propertyList.get('pageSize'),
      searchOptions,
      sortField: sModel && sModel.length > 0 ? sModel[0].colId : undefined,
      sortDirection:
        sModel && sModel.length > 0 ? sModel[0].sort.toUpperCase() : undefined
    });
    if (response && response.results && response.results.length === 1) {
      history.push(`/taxTransparency/property/${response.results[0].propID}/${response.results[0].ownerID}`);
    }
    changeCurrentPage(page);
  };

  const onChangeSort = colId => {
    const sortModel = propertyList.get('sortModel').toJS();
    let newSortModel;
    if (!sortModel || sortModel.length < 1 || sortModel[0].colId !== colId) {
      newSortModel = [
        {
          colId,
          sort: 'asc'
        }
      ];
    }
    if (sortModel && sortModel.length > 0 && sortModel[0].colId === colId) {
      if (sortModel[0].sort === 'asc') {
        newSortModel = [
          {
            colId,
            sort: 'desc'
          }
        ];
      } else {
        newSortModel = [];
      }
    }
    changeSortModel(newSortModel);
    if (propertyList.get('totalCount') <= propertyList.get('pageSize')) {
      return;
    }
    triggerSearch(propertyList.get('currentPage'), newSortModel);
  };

  const renderTable = () => {
    const sortModel = propertyList.get('sortModel').toJS();
    let defaultColumnDefs = searchResultConfig
      .get('data')
      .toJS()
      .map(field => ({
        headerName: field.displayName,
        field: field.id
      }));
    defaultColumnDefs = [
      { headerName: 'SEQ', field: 'seq', suppressSorting: true }
    ].concat(defaultColumnDefs);

    if (
      clientConfig &&
      Boolean(clientConfig.getIn(['data', 'useAccountNumber']))
    ) {
      defaultColumnDefs = defaultColumnDefs.filter(c => c.field !== 'propID');
    } else {
      defaultColumnDefs = defaultColumnDefs.filter(
        c => c.field !== 'accountNumber'
      );
    }
    const properties = propertyList.get('data').toJS();
    const rowData = properties.map((property, index) => {
      const value = {};
      searchResultConfig
        .get('data')
        .toJS()
        .forEach(field => {
          value[field.id] = property[field.id];
        });
      value.seq = index + 1;
      value.ownerID = property.ownerID;
      return value;
    });
    return (
      <table>
        <thead>
          <tr>
            {defaultColumnDefs.map((d, i) => (
              <th key={i} onClick={() => onChangeSort(d.field)}>
                <div className='flex-container'>
                  <span>{d.headerName}</span>
                  {Boolean(sortModel) &&
                    sortModel.length > 0 &&
                    sortModel[0].colId === d.field && (
                      <FontAwesomeIcon
                        icon={
                          sortModel[0].sort === 'asc' ? faArrowDown : faArrowUp
                        }
                      />
                    )}
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rowData.map((r, i) => (
            <tr key={i}>
              {defaultColumnDefs.map((d, j) => (
                <td key={j}>
                  {d.field === 'propID' || d.field === 'accountNumber' ? (
                    <a
                      onClick={() =>
                        history.push(`/taxTransparency/property/${r.propID}/${r.ownerID}`)
                      }
                    >
                      {r[d.field]}
                    </a>
                  ) : (
                    <span>{d.field === 'situs' || d.field === 'dba' ? removeNullCharacter(r[d.field]) : r[d.field]}</span>
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <div>
      <div className='intro-container'>
        <div className='logo-container'>
          <span
            className='main-title neue-font-medium'
          >
            <span className='office-title'>{office} Taxes</span><span> | </span><span>Truth-in-Taxation</span>
          </span>
          {
            clientConfig.getIn(['data', 'showHB3273Link']) ? (
              <span className='tooltip-info-icon-wrap'>
                <Tooltip
                  arrow
                  className='tooltip-info-content'
                  html={
                    <div style={{ maxWidth: '690px', padding: '6px 20px', fontSize: '14px', backgroundColor: '#2f2f2f' }}>
                      <div style={{
                        color: '#deef6e',
                        fontWeight: 'bold',
                      }}>
                        {'HOW TO REGISTER'}
                      </div>
                      <div>
                        1. Click the "<i>Register for Notification</i>" button.
                      </div>
                      <div>
                        2. Create an account or log into the Public Portal.
                      </div>
                      <div>
                        3. Go to the "<i>My Properties</i>" page.
                      </div>
                      <div>
                        4. Locate the "<i>Receive Update</i>" column and click the checkbox.
                      </div>
                      <img src={screenshotImage} style={{ width: '350px' }} />
                      <div style={{ fontWeight: 'bold' }}>
                        We will generate an email notice under the following conditions:
                      </div>
                      <div>
                        {'- Market value change on the property.'}
                      </div>
                      <div>
                        {'- Taxable value change on the property.'}
                      </div>
                      <div>
                        {'- Taxing unit tax rate change.'}
                      </div>
                      <div>
                        {'- Taxing unit hearing notice (added/removed/deleted).'}
                      </div>
                    </div>
                  }
                  position='bottom'
                  trigger='mouseenter'
                >
                  <div className='register-link' onClick={() => {
                    window.open(clientConfig.getIn(['data', 'hb3273Url']));
                  }}>
                    <BellIcon>
                      <g>
                        <path d="M0 12.321a1.026 1.026 0 0 0 1.027 1.027h12.32a1.027 1.027 0 0 0 .767-1.71l-.237-.266a6.169 6.169 0 0 1-1.556-4.094v-.6a5.136 5.136 0 0 0-4.107-5.035v-.616a1.027 1.027 0 1 0-2.053 0v.616a5.136 5.136 0 0 0-4.108 5.031v.6A6.175 6.175 0 0 1 .5 11.371l-.237.266a1.033 1.033 0 0 0-.263.684z" style={{opacity:.4}}/>
                        <path d="M164.107 448a2.053 2.053 0 1 1-4.107 0h4.107z" transform="translate(-154.866 -433.626)" />
                      </g>
                    </BellIcon >
                    <div>Register for Notification</div>
                  </div>
                </Tooltip>
              </span>
            ) : (<div />)
          }
        </div>
        <div
          className='text-container'
        >
          {clientConfig && clientConfig.getIn(['data', 'showBetaMessage']) === 1 && clientConfig.getIn(['data', 'betaMessage']) ? (
            <div className='disclaimer'>{clientConfig.getIn(['data', 'betaMessage'])}</div>
          ) : null}
          <div className='main-content-wrapper'>
            <div className='main-content-container'>
              <span>
                Truth-in-Taxation is a concept embodied in the Texas Constitution
                that requires local taxing units to make taxpayers aware of tax rate
                proposals and to afford taxpayers the opportunity to roll back or
                limit tax increases.
              </span>
              <span>
                Creating a budget and adopting a property tax rate to support that
                budget are major functions of a taxing unit's governing body. This
                is accomplished by following Truth-in-Taxation requirements to
                ensure the public is informed of any increases. The type of taxing
                unit determines its applicable{' '}
                <a
                  href='https://comptroller.texas.gov/taxes/property-tax/truth-in-taxation/index.php'
                  style={{ color: '#3949ab' }}
                  target='_blank'
                >
                  Truth-in-Taxation requirements.
                </a>
              </span>
              <span>
                This website provides information concerning the property taxes that
                may be imposed on your property by local taxing units, the dates and
                locations of any public hearings on the tax rates of the taxing
                units, and the dates and locations of meetings of the governing
                bodies of the taxing units to vote on the tax rates, together with
                other important property tax information.
              </span>
              <span>
                The 86th Texas Legislature modified the manner in which the voter-approval tax rate is calculated to limit the rate of growth of property taxes in the state.
              </span>
              <span>
                Please note: The Texas Legislature does not set the tax amount of
                your local taxes. Your property tax burden is decided by your
                locally elected officials (school trustees, city council, county
                commissioners, et al) and all inquiries concerning your taxes
                should be directed to those officials.
              </span>
            </div>
            <div className='left-content-container'>
              <div>
                <img src={mainImage} />
              </div>
            </div>
          </div>
          <div className='main-content-wrapper'>
            {clientConfig && clientConfig.getIn(['data', 'showCustomCADAppealMessage']) === 1 && clientConfig.getIn(['data', 'cadAppealMessage']) ? (
              <AppealMessageContent color={clientConfig.getIn(['data', 'cadAppealMessageColor']) || '#000000'} dangerouslySetInnerHTML={{ __html: clientConfig.getIn(['data', 'cadAppealMessage']) }} />
            ) : null}
          </div>
        </div>
      </div>
      <div className='page property-search'>
        <div className='search-fields-container'>
          <CustomTooltip
            content={
              <div style={{ fontSize: '1rem', lineHeight: '1.5rem' }}>
                Enter any part of the property id, name or address of the
                property you wish to search for.
                <br />
                To search for only a name: "William B Travis"
                <br />
                To search for a property id: "12345"
                <br />
                To narrow down your search: "William B Travis on 1100 Congress
                Ave
              </div>
            }
          >
            <div className='search-bar-container'>
              <TextInput
                InputProps={{
                  disableUnderline: true,
                  style: { border: '1px solid #333fb8', backgroundColor: '#efefff' }
                }}
                input={{
                  onChange: changeQueryString,
                  onBlur: () => { },
                  value: queryString
                }}
                meta={{
                  touched: false
                }}
                placeholder={window.innerWidth > 425 ? 'Search by Name, Address or Property ID (PID#), for example "William Travis" or "1100 Congress Ave" or "151999"' : ''}
                onKeyPress={e => {
                  if (e.key === 'Enter') {
                    triggerSearch(1);
                  }
                }}
              />
              <a className='search-icon'>
                <img src={searchIcon} />
              </a>
              <a className='times-icon' onClick={() => changeQueryString('')}>
                <img src={closeIcon} />
              </a>
            </div>
          </CustomTooltip>
          <span className='placeholder-text'>Search by Name, Address or Property ID (PID#), for example "William Travis" or "1100 Congress Ave" or "151999"</span>
          <Button
            color='primary'
            disabled={!queryString}
            style={{ height: 47 }}
            variant='contained'
            onClick={() => triggerSearch(1)}
          >
            SEARCH
          </Button>
        </div>
        {importStatusJs === 'In Progress' ? (
          <RefreshIndicator />
        ) : (
          <div className='search-results-container'>
            <div className='list-table'>
              {propertyList.get('state') === fetchingState.FETCHING && (
                <div style={{ textAlign: 'center' }}>
                  <CircularProgress
                    style={{ marginTop: 15, display: 'inline-block' }}
                  />
                </div>
              )}
              {propertyList.get('state') === fetchingState.LOADED &&
                propertyList.get('totalCount') > 0 && (
                  <div>{renderTable()}</div>
                )}
              {propertyList.get('state') !== fetchingState.FETCHING &&
                (!propertyList.get('data') ||
                  propertyList.get('totalCount') === 0) && <NoDataHolder />}
            </div>
            {propertyList.get('totalCount') > 0 && (
              <Pagination
                currentPage={propertyList.get('currentPage')}
                pageSize={propertyList.get('pageSize')}
                totalCount={propertyList.get('totalCount')}
                onChangePageSize={changePageSize}
                onPageClick={triggerSearch}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

PropertySearch.propTypes = {
  changeCurrentPage: PropTypes.func.isRequired,
  changePageSize: PropTypes.func.isRequired,
  changeQueryString: PropTypes.func.isRequired,
  changeSortModel: PropTypes.func.isRequired,
  clientConfig: ImmutablePropTypes.map,
  fetchImportStatus: PropTypes.func.isRequired,
  fetchSearchResultConfig: PropTypes.func.isRequired,
  history: PropTypes.object,
  importStatus: PropTypes.string,
  office: PropTypes.string.isRequired,
  property: ImmutablePropTypes.map,
  propertyList: ImmutablePropTypes.map,
  queryString: PropTypes.string,
  search: PropTypes.func.isRequired,
  searchResultConfig: ImmutablePropTypes.map
};

const AppealMessageContent = styled.div`
  & > * {
    color: ${props => props.color ? props.color : '#000000'} !important;
  }

  a {
    color: ${props => props.color ? props.color : '#000000'} !important;
  }
`;

const BellIcon = styled(SvgIcon)`
  margin-bottom: -8px;
`;

const mapDispatchToProps = {
  changeCurrentPage: globalActions.changeCurrentPage,
  changePageSize: globalActions.changePageSize,
  changeQueryString: globalActions.changeQueryString,
  changeSortModel: globalActions.changeSortModel,
  fetchSearchResultConfig: globalActions.fetchSearchResultConfig,
  search: globalActions.search,
  fetchImportStatus: globalActions.fetchImportStatus
};

const enhance = connect(
  selector,
  mapDispatchToProps
);

export default enhance(PropertySearch);
